import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { Animated, TouchableOpacity, InteractionManager } from 'react-native';
import Text from 'design-system/Text';
import { useErrorStatusbarHeight } from 'utils/statusBar';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { Spacer } from 'design-system';
import { useScrambleMode } from 'hooks';
import { isWeb } from '../constants';
const StatusBarScrambled = () => {
    const styles = useStyles(styleSet);
    const errorStatusBarHeight = useErrorStatusbarHeight();
    const { setScrambled, scrambled } = useScrambleMode();
    const [height] = useState(new Animated.Value(isWeb ? 0 : -errorStatusBarHeight));
    const topMargin = useRef(new Animated.Value(0)).current;
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (scrambled)
            InteractionManager.runAfterInteractions(() => setVisible(true));
        const animation = isWeb
            ? Animated.timing(topMargin, {
                toValue: scrambled ? errorStatusBarHeight : 0,
                useNativeDriver: true,
            })
            : Animated.timing(height, {
                toValue: scrambled ? 0 : -errorStatusBarHeight,
                useNativeDriver: true,
            });
        animation.start(() => setVisible(scrambled));
    }, [errorStatusBarHeight, topMargin, scrambled, height]);
    const scrambleStatusBar = useMemo(() => {
        const transformStyle = { transform: [{ translateY: height }] };
        const dynamicHeight = { height: isWeb ? topMargin : errorStatusBarHeight };
        const positionStyle = {
            position: (isWeb ? 'relative' : 'absolute'),
        };
        return (<Animated.View style={[styles.statusbar, dynamicHeight, transformStyle, positionStyle]}>
        <TouchableOpacity onPress={() => setScrambled(false)} style={styles.touchable}>
          <Text Text-12 White>
            Privacy mode enabled. {isWeb ? 'Click' : 'Tap'} here to dismiss.
          </Text>
          {isWeb ? <Spacer h={8}/> : null}
        </TouchableOpacity>
      </Animated.View>);
    }, [
        errorStatusBarHeight,
        height,
        styles.statusbar,
        styles.touchable,
        topMargin,
        setScrambled,
    ]);
    if (!visible && !isWeb)
        return null;
    return scrambleStatusBar;
};
const styleSet = createStyleSheets((colors) => ({
    statusbar: {
        top: 0,
        left: 0,
        right: 0,
        backgroundColor: colors.status.positive,
    },
    touchable: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
}));
export default memo(StatusBarScrambled);
